var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("作业量分布"),_c('span',{staticClass:"remark m-l-10"},[_vm._v("(单位：个)")])]),_c('div',{staticStyle:{"width":"100%","height":"300px"},attrs:{"id":"workMonthReport"}})])
}]

export { render, staticRenderFns }